import React, { useState, useEffect } from 'react';
import { BarChart2 } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || '/api';
const getAuthToken = () => typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;

interface PostROIBadgeProps {
  scoopId: string;
  isOwner: boolean;
}

export default function PostROIBadge({ scoopId, isOwner }: PostROIBadgeProps) {
  const [stats, setStats] = useState<{ totalVisits: number; totalRevenueCents: number } | null>(null);

  useEffect(() => {
    if (!isOwner) return;
    const token = getAuthToken();
    if (!token) return;
    fetch(`${API_URL}/engagement/attribution/stats/${scoopId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d && (d.totalVisits > 0 || d.totalRevenueCents > 0)) setStats(d);
      })
      .catch(() => {});
  }, [scoopId, isOwner]);

  if (!stats) return null;

  const label = stats.totalRevenueCents > 0
    ? `$${(stats.totalRevenueCents / 100).toFixed(0)} in sales`
    : `${stats.totalVisits} shop ${stats.totalVisits === 1 ? 'visit' : 'visits'}`;

  return (
    <span className="inline-flex items-center gap-1 text-[11px] text-emerald-400/70 font-medium">
      <BarChart2 size={10} />
      {label}
    </span>
  );
}
